export default __webpack_public_path__ + "static/tools-bg2-d1bb9f6443d2f6a2a3d0f81948174028.svg";